import { useState, useRef } from "react";

import ShareIcon from "@mui/icons-material/Share";
import PlayIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";

// components
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import OldLottie from "react-lottie";
import Lottie from "react-lottie-player";
import Fade from "@mui/material/Fade";
import LinearProgress from "@mui/material/LinearProgress";

//hooks
import { useDivination } from "hooks/divine";

// assets
import loadingAnimation from "assets/lotties/rightPanelLoading.json";
import countdownAnimation from "assets/lotties/countdown.json";

const styles = {
  inputField: {
    color: "#55ff55",
    borderColor: "#55ff55",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "5px",
    padding: "0.5%",
    width: "100%",
    margin: "1%",
  },
  button: {
    backgroundColor: "#55ff5500",
    color: "#00FF00",
    borderColor: "#00FF00",
    borderWidth: "1px",
    borderStyle: "solid",
    margin: "1%",
    padding: "1%",
    height: "100%",
    width: "100%",
  },
  text: {
    color: "#55ff55",
    textAlign: "left",
  },
};

function Navigator(props) {
  const audioRef = useRef(null);
  const { mutate, isLoading } = useDivination();
  const [countingDown, setCountingDown] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [phase, setPhase] = useState(0);
  const [divinationUrl, setDivinationUrl] = useState(null);
  const [divinationMetadata, setDivinationMetadata] = useState({});
  const [isPlayed, setIsPlayed] = useState(false);

  return (
    <>
      {isLoading ? (
        <OldLottie
          options={{
            loop: true,
            autoplay: true,
            animationData: loadingAnimation,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
            initialSegment: [11, 121],
          }}
          height={"100%"}
          width={"80%"}
        />
      ) : countingDown ? (
        <Lottie
          loop={false}
          play={true}
          animationData={countdownAnimation}
          rendererSettings={{
            preserveAspectRatio: "xMidYMid slice",
          }}
          segments={[61, 157]}
          onComplete={() => {
            // console.log("completed!");
            setCountingDown(false);
            setIsReady(true);
            audioRef.current.play();
            setIsPlayed(true);
          }}
          onLoopComplete={() => {
            // console.log("completed!");
          }}
          style={{
            position: "relative",
            left: "25%",
            height: "100%",
            width: "50%",
            alignSelf: "center",
          }}
        />
      ) : !isReady ? (
        <Grid
          Container
          style={{
            height: "100%",
            alignSelf: "center",
            padding: "1% 6% 0% 6%",
          }}
        >
          <Grid
            container
            columnSpacing={2}
            // rowSpacing={2}
            style={{
              width: "100%",
              height: "100%",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Grid item xs={12}>
              <Fade
                in={phase >= 0}
                timeout={2000}
                onEntered={() => {
                  // console.log("animation end!");
                  setPhase(1);
                }}
              >
                <Typography variant={"body2"} style={styles.text}>
                  Stay calm and take a deep breath,
                </Typography>
              </Fade>
            </Grid>

            <Grid item xs={12}>
              <Fade
                in={phase >= 1}
                timeout={3000}
                onEntered={() => {
                  // console.log("animation end!");
                  setPhase(2);
                }}
              >
                <Typography variant="body" style={styles.text}>
                  Prepare yourself ...
                </Typography>
              </Fade>
            </Grid>
            <Grid item xs={10}>
              <Fade in={phase >= 2} timeout={2000}>
                <Button
                  variant="outlined"
                  style={styles.button}
                  onClick={() => {
                    // console.log("divined");
                    mutate(
                      {},
                      {
                        onSuccess: (response) => {
                          // console.log("response is: ",response)
                          if (response && response.status === "OK") {
                            setDivinationUrl(response.url);
                            setDivinationMetadata(response.metadata);
                            setCountingDown(true);
                            // setUser(response.user);
                            // setAuthCookie(response.userToken);
                            // setUserInStorage(response.user);
                            // setRightState("navigator")
                          }
                        },
                        onError: (error) => {
                          // console.log(error);
                        },
                      }
                    );
                  }}
                >
                  I am ready, Let's Divine!
                </Button>
              </Fade>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          Container
          style={{
            height: "100%",
            alignSelf: "center",
            padding: "1% 6% 0% 6%",
          }}
        >
          <Grid
            container
            columnSpacing={2}
            columns={24}
            // rowSpacing={2}
            style={{
              width: "100%",
              height: "100%",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Grid item xs={24}>
              <Typography style={styles.text}>
                Listen carefully and make your clairvoyance...
              </Typography>
              {/* </Fade> */}
            </Grid>

            <Grid item xs={20}>
              <audio
                ref={audioRef}
                crossOrigin="anonymous"
                src={divinationUrl}
              ></audio>
              <LinearProgress
                variant="determinate"
                value={
                  (audioRef?.current?.currentTime /
                    divinationMetadata?.duration) *
                  100
                }
                color="success"
              />
            </Grid>
            <Grid item xs={1} style={{ textAlign: "left" }}>
              <Button
                variant="outlined"
                style={{
                  ...styles.button,
                  minWidth: "25px",
                  minHeight: "25px",
                  transform: "translateX(-50%)",
                }}
                onClick={() => {
                  // console.log("played!");
                  if (isPlayed) {
                    audioRef.current.pause();
                    setIsPlayed(false);
                  } else {
                    audioRef.current.play();
                    setIsPlayed(true);
                  }
                }}
              >
                {isPlayed ? (
                  <PauseIcon fontSize="20%"></PauseIcon>
                ) : (
                  <PlayIcon fontSize="10%"></PlayIcon>
                )}
              </Button>
            </Grid>
            <Grid item xs={1} style={{ textAlign: "left" }}>
              <Button
                variant="outlined"
                style={{
                  ...styles.button,
                  minWidth: "25px",
                  minHeight: "25px",
                  padding: "20%",
                }}
                onClick={() => {
                  // console.log("played!");
                  // navigator
                  //   .share({
                  //     title: "MDN",
                  //     text: "Learn web development on MDN!",
                  //     url: "https://developer.mozilla.org",
                  //   })
                  //   .then((res) => console.log("shared successfully"))
                  //   .catch((err) => console.log("error!", err));
                }}
              >
                {<ShareIcon fontSize="20%"></ShareIcon>}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default Navigator;
